import type { BrokerTask } from "@dune/types";
import { Button, DataTable } from "@dune/ui";
import { Plus } from "lucide-react";
import React, { useMemo, useState } from "react";
import { useMe } from "../../../../../api/queries/users.queries";
import { useRequiredParams } from "../../../../../hooks/useRequiredParams";
import { useTaskActions } from "../../../../../stores/task.store";
import CreateManualTaskModal from "../modals/CreateManualTaskModal";
import { tasksColumns } from "./tasksColumns";

interface TasksTabProps {
	tasks: BrokerTask[] | undefined;
	isLoading: boolean;
	error: unknown;
}

const TasksTab: React.FC<TasksTabProps> = ({ tasks, isLoading, error }) => {
	const { selectTask } = useTaskActions();
	const { id } = useRequiredParams<{ id: string }>();
	const brokerId = Number.parseInt(id);
	const { me: user } = useMe();
	const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

	const handleRowClick = (task: BrokerTask) => {
		selectTask(task.id.toString());
	};

	const tasksData = useMemo(() => {
		return tasks || [];
	}, [tasks]);

	if (error) return <div>Erreur lors du chargement des tâches.</div>;

	const isDuneRole = user?.role === "DUNE";

	return (
		<div className="h-full">
			<div className="flex items-center justify-between mb-2 w-full">
				<h2 className="text-lg text-text-main-blue font-semibold">Tâches</h2>
				{isDuneRole && (
					<Button
						onClick={() => setIsCreateModalOpen(true)}
						size="sm"
						className="flex items-center gap-2"
					>
						<Plus size={16} />
						Créer une tâche
					</Button>
				)}
			</div>
			<DataTable
				data={tasksData}
				columns={tasksColumns}
				noResultsText="Aucune tâche trouvée"
				isLoading={isLoading}
				onRowClick={isDuneRole ? handleRowClick : undefined}
				variant="static-clean"
			/>
			<CreateManualTaskModal
				open={isCreateModalOpen}
				onOpenChange={setIsCreateModalOpen}
				brokerId={brokerId}
			/>
		</div>
	);
};

export default TasksTab;
